
export const logChatgptEvent = (clickedButton: string) => {
    dataLayer.push({
        event: 'ga4Event',
        event_name: 'chatgpt',
        clicked_button: clickedButton
    });
};
